var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('EditLocationForm',{attrs:{"initial-form-data":_vm.location,"on-form-saved":_vm.onLocationSaved}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }